/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkProductRequest,
  ErrorList,
  Product,
  ProductExpressUpdateElementList,
  ProductList,
  ProductReferenceList,
  ProductSearchPage,
  Review,
  ReviewList,
  SILPriceInfo,
  Stock,
  StoreFinderStockSearchPage,
  SuggestionList,
} from '../models';
import {
    BulkProductRequestFromJSON,
    BulkProductRequestToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
    ProductFromJSON,
    ProductToJSON,
    ProductExpressUpdateElementListFromJSON,
    ProductExpressUpdateElementListToJSON,
    ProductListFromJSON,
    ProductListToJSON,
    ProductReferenceListFromJSON,
    ProductReferenceListToJSON,
    ProductSearchPageFromJSON,
    ProductSearchPageToJSON,
    ReviewFromJSON,
    ReviewToJSON,
    ReviewListFromJSON,
    ReviewListToJSON,
    SILPriceInfoFromJSON,
    SILPriceInfoToJSON,
    StockFromJSON,
    StockToJSON,
    StoreFinderStockSearchPageFromJSON,
    StoreFinderStockSearchPageToJSON,
    SuggestionListFromJSON,
    SuggestionListToJSON,
} from '../models';

export interface CountProductStockByLocationRequest {
    baseSiteId: string;
    productCode: string;
    latitude?: number;
    location?: string;
    longitude?: number;
    sapCommerceCloudCustomerId?: string;
}

export interface CountProductsRequest {
    baseSiteId: string;
    query?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface CreateProductReviewRequest {
    baseSiteId: string;
    productCode: string;
    review: Review;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface FetchPricesRequest {
    baseSiteId: string;
    sILPriceInfo: SILPriceInfo;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetExpressUpdateProductsRequest {
    baseSiteId: string;
    timestamp: string;
    catalog?: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetLocationProductStockRequest {
    baseSiteId: string;
    productCode: string;
    currentPage?: number;
    fields?: string;
    latitude?: number;
    location?: string;
    longitude?: number;
    pageSize?: number;
    sapCommerceCloudCustomerId?: string;
}

export interface GetProductRequest {
    baseSiteId: string;
    productCode: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetProductReferencesRequest {
    baseSiteId: string;
    productCode: string;
    fields?: string;
    pageSize?: number;
    referenceType?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetProductReviewsRequest {
    baseSiteId: string;
    productCode: string;
    fields?: string;
    maxCount?: number;
    sapCommerceCloudCustomerId?: string;
}

export interface GetProductsRequest {
    baseSiteId: string;
    contracts?: Array<string>;
    currentPage?: number;
    excludeContractedProductsB2B?: Array<string>;
    fB2BCustomerContracts?: boolean;
    fields?: string;
    pageSize?: number;
    query?: string;
    searchQueryContext?: string;
    sort?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetProductsBulkRequest {
    baseSiteId: string;
    bulkProductRequest: BulkProductRequest;
    fields?: string;
    omitRestrictions?: boolean;
    sapCommerceCloudCustomerId?: string;
}

export interface GetProductsBulkSolrRequest {
    baseSiteId: string;
    bulkProductRequest: BulkProductRequest;
    currentPage?: number;
    fields?: string;
    pageSize?: number;
    q?: string;
    searchQueryContext?: GetProductsBulkSolrSearchQueryContextEnum;
    sort?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetStoreProductStockRequest {
    baseSiteId: string;
    productCode: string;
    storeName: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetSuggestionsRequest {
    baseSiteId: string;
    term: string;
    fields?: string;
    max?: number;
    sapCommerceCloudCustomerId?: string;
}

/**
 * ProductsApi - interface
 * 
 * @export
 * @interface ProductsApiInterface
 */
export interface ProductsApiInterface {
    /**
     * In the response header, the \"x-total-count\" property indicates the total number of stock levels of a product. Either location parameter or longitude and latitude parameters are required.
     * @summary Retrieves the total number of stock levels of a product.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier.
     * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
     * @param {string} [location] Free-text location
     * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    countProductStockByLocationRaw(requestParameters: CountProductStockByLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * In the response header, the \"x-total-count\" property indicates the total number of stock levels of a product. Either location parameter or longitude and latitude parameters are required.
     * Retrieves the total number of stock levels of a product.
     */
    countProductStockByLocation(requestParameters: CountProductStockByLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * In the response header, the \"x-total-count\" property indicates the total number of products for the query.
     * @summary Retrieves the total number of products.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [query] Formatted query string. It contains query criteria like free text search, facet. The format is &lt;freeTextSearch&gt;:&lt;sort&gt;:&lt;facetKey1&gt;:&lt;facetValue1&gt;:...:&lt;facetKeyN&gt;:&lt;facetValueN&gt;.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    countProductsRaw(requestParameters: CountProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * In the response header, the \"x-total-count\" property indicates the total number of products for the query.
     * Retrieves the total number of products.
     */
    countProducts(requestParameters: CountProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates a customer review for a product as an anonymous user.
     * @summary Creates a customer review as an anonymous user.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier.
     * @param {Review} review 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    createProductReviewRaw(requestParameters: CreateProductReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Review>>;

    /**
     * Creates a customer review for a product as an anonymous user.
     * Creates a customer review as an anonymous user.
     */
    createProductReview(requestParameters: CreateProductReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Review>;

    /**
     * Retrieve a list of prices for a list of product codes by customer.
     * @param {string} baseSiteId Base site identifier
     * @param {SILPriceInfo} sILPriceInfo 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    fetchPricesRaw(requestParameters: FetchPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SILPriceInfo>>;

    /**
     * Retrieve a list of prices for a list of product codes by customer.
     */
    fetchPrices(requestParameters: FetchPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SILPriceInfo>;

    /**
     * Retrieves products that were added to the express update feed. Only the properties that were updated after the specified timestamp are returned. The queue is cleared using a defined cronjob.
     * @summary Retrieves products that were added to the express update feed.
     * @param {string} baseSiteId Base site identifier
     * @param {string} timestamp Only products that are more recent than the given parameter are returned. The value should be in ISO-8601 format: 2018-01-09T16:28:45+0000.
     * @param {string} [catalog] Only products from this catalog are returned. Format: catalogId:catalogVersion.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getExpressUpdateProductsRaw(requestParameters: GetExpressUpdateProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductExpressUpdateElementList>>;

    /**
     * Retrieves products that were added to the express update feed. Only the properties that were updated after the specified timestamp are returned. The queue is cleared using a defined cronjob.
     * Retrieves products that were added to the express update feed.
     */
    getExpressUpdateProducts(requestParameters: GetExpressUpdateProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductExpressUpdateElementList>;

    /**
     * The stock levels are sorted by distance from the specified location, which is defined using the free-text location parameter or the longitude and latitude parameters. Either location parameter or longitude and latitude parameters are required.
     * @summary Retrieves the stock level of a product.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier.
     * @param {number} [currentPage] Current result page. Default value is 0.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
     * @param {string} [location] Free-text location
     * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
     * @param {number} [pageSize] Number of results returned per page.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getLocationProductStockRaw(requestParameters: GetLocationProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreFinderStockSearchPage>>;

    /**
     * The stock levels are sorted by distance from the specified location, which is defined using the free-text location parameter or the longitude and latitude parameters. Either location parameter or longitude and latitude parameters are required.
     * Retrieves the stock level of a product.
     */
    getLocationProductStock(requestParameters: GetLocationProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreFinderStockSearchPage>;

    /**
     * Retrieves the details of a single product using the product identifier.
     * @summary Retrieves product details.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getProductRaw(requestParameters: GetProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Product>>;

    /**
     * Retrieves the details of a single product using the product identifier.
     * Retrieves product details.
     */
    getProduct(requestParameters: GetProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Product>;

    /**
     * Retrieves the references using the product code and reference type.
     * @summary Retrieves the product references.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [pageSize] Number of results returned per page.
     * @param {string} [referenceType] Comma-separated list of reference types. If not specified, all types of product references will be used. Example: ACCESSORIES,BASE_PRODUCT.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getProductReferencesRaw(requestParameters: GetProductReferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductReferenceList>>;

    /**
     * Retrieves the references using the product code and reference type.
     * Retrieves the product references.
     */
    getProductReferences(requestParameters: GetProductReferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductReferenceList>;

    /**
     * Retrieves all the reviews for a product. To limit the number of reviews returned, use the maxCount parameter.
     * @summary Retrieves the reviews of a product.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [maxCount] Maximum number of reviews.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getProductReviewsRaw(requestParameters: GetProductReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReviewList>>;

    /**
     * Retrieves all the reviews for a product. To limit the number of reviews returned, use the maxCount parameter.
     * Retrieves the reviews of a product.
     */
    getProductReviews(requestParameters: GetProductReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReviewList>;

    /**
     * 
     * @param {string} baseSiteId Base site identifier
     * @param {Array<string>} [contracts] Filter by contracts.
     * @param {number} [currentPage] The current result page requested.
     * @param {Array<string>} [excludeContractedProductsB2B] Exclude contracted products for these b2b customers ids
     * @param {boolean} [fB2BCustomerContracts] Filter by the b2b customer\&#39;s contracts
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
     * @param {string} [searchQueryContext] The context to be used in the search query.
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getProductsRaw(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductSearchPage>>;

    /**
     */
    getProducts(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductSearchPage>;

    /**
     * 
     * @param {string} baseSiteId Base site identifier
     * @param {BulkProductRequest} bulkProductRequest 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {boolean} [omitRestrictions] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getProductsBulkRaw(requestParameters: GetProductsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductList>>;

    /**
     */
    getProductsBulk(requestParameters: GetProductsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductList>;

    /**
     * 
     * @param {string} baseSiteId Base site identifier
     * @param {BulkProductRequest} bulkProductRequest 
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [q] Search term(query). Query format is: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
     * @param {'CONTACT_ADDRESS' | 'DEFAULT' | 'BILLING_ADDRESS' | 'SUGGESTIONS' | 'USER' | 'FL_SEARCH_PRODUCTS' | 'ORG_SEARCH'} [searchQueryContext] Exclude obsolete products
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getProductsBulkSolrRaw(requestParameters: GetProductsBulkSolrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductSearchPage>>;

    /**
     */
    getProductsBulkSolr(requestParameters: GetProductsBulkSolrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductSearchPage>;

    /**
     * Retrieves the stock level of a product for the store.
     * @summary Retrieves the stock level of a product.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} productCode Product identifier.
     * @param {string} storeName Store identifier.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getStoreProductStockRaw(requestParameters: GetStoreProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stock>>;

    /**
     * Retrieves the stock level of a product for the store.
     * Retrieves the stock level of a product.
     */
    getStoreProductStock(requestParameters: GetStoreProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stock>;

    /**
     * Retrieves the suggestions related to a specified term and limits the results according to the value of the max parameter.
     * @summary Retrieves the available suggestions.
     * @param {string} baseSiteId Base site identifier
     * @param {string} term Specified term. The suggestions will be given based on it.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [max] Maximum number of results.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApiInterface
     */
    getSuggestionsRaw(requestParameters: GetSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuggestionList>>;

    /**
     * Retrieves the suggestions related to a specified term and limits the results according to the value of the max parameter.
     * Retrieves the available suggestions.
     */
    getSuggestions(requestParameters: GetSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuggestionList>;

}

/**
 * 
 */
export class ProductsApi extends runtime.BaseAPI implements ProductsApiInterface {

    /**
     * In the response header, the \"x-total-count\" property indicates the total number of stock levels of a product. Either location parameter or longitude and latitude parameters are required.
     * Retrieves the total number of stock levels of a product.
     */
    async countProductStockByLocationRaw(requestParameters: CountProductStockByLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling countProductStockByLocation.');
        }

        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling countProductStockByLocation.');
        }

        const queryParameters: any = {};

        if (requestParameters.latitude !== undefined) {
            queryParameters['latitude'] = requestParameters.latitude;
        }

        if (requestParameters.location !== undefined) {
            queryParameters['location'] = requestParameters.location;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['longitude'] = requestParameters.longitude;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/{productCode}/stock`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * In the response header, the \"x-total-count\" property indicates the total number of stock levels of a product. Either location parameter or longitude and latitude parameters are required.
     * Retrieves the total number of stock levels of a product.
     */
    async countProductStockByLocation(requestParameters: CountProductStockByLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.countProductStockByLocationRaw(requestParameters, initOverrides);
    }

    /**
     * In the response header, the \"x-total-count\" property indicates the total number of products for the query.
     * Retrieves the total number of products.
     */
    async countProductsRaw(requestParameters: CountProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling countProducts.');
        }

        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/search`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * In the response header, the \"x-total-count\" property indicates the total number of products for the query.
     * Retrieves the total number of products.
     */
    async countProducts(requestParameters: CountProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.countProductsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a customer review for a product as an anonymous user.
     * Creates a customer review as an anonymous user.
     */
    async createProductReviewRaw(requestParameters: CreateProductReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Review>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createProductReview.');
        }

        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling createProductReview.');
        }

        if (requestParameters.review === null || requestParameters.review === undefined) {
            throw new runtime.RequiredError('review','Required parameter requestParameters.review was null or undefined when calling createProductReview.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/{productCode}/reviews`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReviewToJSON(requestParameters.review),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReviewFromJSON(jsonValue));
    }

    /**
     * Creates a customer review for a product as an anonymous user.
     * Creates a customer review as an anonymous user.
     */
    async createProductReview(requestParameters: CreateProductReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Review> {
        const response = await this.createProductReviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a list of prices for a list of product codes by customer.
     */
    async fetchPricesRaw(requestParameters: FetchPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SILPriceInfo>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling fetchPrices.');
        }

        if (requestParameters.sILPriceInfo === null || requestParameters.sILPriceInfo === undefined) {
            throw new runtime.RequiredError('sILPriceInfo','Required parameter requestParameters.sILPriceInfo was null or undefined when calling fetchPrices.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/prices`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SILPriceInfoToJSON(requestParameters.sILPriceInfo),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SILPriceInfoFromJSON(jsonValue));
    }

    /**
     * Retrieve a list of prices for a list of product codes by customer.
     */
    async fetchPrices(requestParameters: FetchPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SILPriceInfo> {
        const response = await this.fetchPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves products that were added to the express update feed. Only the properties that were updated after the specified timestamp are returned. The queue is cleared using a defined cronjob.
     * Retrieves products that were added to the express update feed.
     */
    async getExpressUpdateProductsRaw(requestParameters: GetExpressUpdateProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductExpressUpdateElementList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getExpressUpdateProducts.');
        }

        if (requestParameters.timestamp === null || requestParameters.timestamp === undefined) {
            throw new runtime.RequiredError('timestamp','Required parameter requestParameters.timestamp was null or undefined when calling getExpressUpdateProducts.');
        }

        const queryParameters: any = {};

        if (requestParameters.catalog !== undefined) {
            queryParameters['catalog'] = requestParameters.catalog;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.timestamp !== undefined) {
            queryParameters['timestamp'] = requestParameters.timestamp;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/expressupdate`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductExpressUpdateElementListFromJSON(jsonValue));
    }

    /**
     * Retrieves products that were added to the express update feed. Only the properties that were updated after the specified timestamp are returned. The queue is cleared using a defined cronjob.
     * Retrieves products that were added to the express update feed.
     */
    async getExpressUpdateProducts(requestParameters: GetExpressUpdateProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductExpressUpdateElementList> {
        const response = await this.getExpressUpdateProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The stock levels are sorted by distance from the specified location, which is defined using the free-text location parameter or the longitude and latitude parameters. Either location parameter or longitude and latitude parameters are required.
     * Retrieves the stock level of a product.
     */
    async getLocationProductStockRaw(requestParameters: GetLocationProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreFinderStockSearchPage>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getLocationProductStock.');
        }

        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling getLocationProductStock.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.latitude !== undefined) {
            queryParameters['latitude'] = requestParameters.latitude;
        }

        if (requestParameters.location !== undefined) {
            queryParameters['location'] = requestParameters.location;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['longitude'] = requestParameters.longitude;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/{productCode}/stock`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreFinderStockSearchPageFromJSON(jsonValue));
    }

    /**
     * The stock levels are sorted by distance from the specified location, which is defined using the free-text location parameter or the longitude and latitude parameters. Either location parameter or longitude and latitude parameters are required.
     * Retrieves the stock level of a product.
     */
    async getLocationProductStock(requestParameters: GetLocationProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreFinderStockSearchPage> {
        const response = await this.getLocationProductStockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the details of a single product using the product identifier.
     * Retrieves product details.
     */
    async getProductRaw(requestParameters: GetProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Product>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getProduct.');
        }

        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling getProduct.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/{productCode}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductFromJSON(jsonValue));
    }

    /**
     * Retrieves the details of a single product using the product identifier.
     * Retrieves product details.
     */
    async getProduct(requestParameters: GetProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Product> {
        const response = await this.getProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the references using the product code and reference type.
     * Retrieves the product references.
     */
    async getProductReferencesRaw(requestParameters: GetProductReferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductReferenceList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getProductReferences.');
        }

        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling getProductReferences.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.referenceType !== undefined) {
            queryParameters['referenceType'] = requestParameters.referenceType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/{productCode}/references`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductReferenceListFromJSON(jsonValue));
    }

    /**
     * Retrieves the references using the product code and reference type.
     * Retrieves the product references.
     */
    async getProductReferences(requestParameters: GetProductReferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductReferenceList> {
        const response = await this.getProductReferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all the reviews for a product. To limit the number of reviews returned, use the maxCount parameter.
     * Retrieves the reviews of a product.
     */
    async getProductReviewsRaw(requestParameters: GetProductReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReviewList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getProductReviews.');
        }

        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling getProductReviews.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.maxCount !== undefined) {
            queryParameters['maxCount'] = requestParameters.maxCount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/{productCode}/reviews`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReviewListFromJSON(jsonValue));
    }

    /**
     * Retrieves all the reviews for a product. To limit the number of reviews returned, use the maxCount parameter.
     * Retrieves the reviews of a product.
     */
    async getProductReviews(requestParameters: GetProductReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReviewList> {
        const response = await this.getProductReviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductsRaw(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductSearchPage>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getProducts.');
        }

        const queryParameters: any = {};

        if (requestParameters.contracts) {
            queryParameters['contracts'] = requestParameters.contracts;
        }

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.excludeContractedProductsB2B) {
            queryParameters['excludeContractedProductsB2B'] = requestParameters.excludeContractedProductsB2B;
        }

        if (requestParameters.fB2BCustomerContracts !== undefined) {
            queryParameters['fB2BCustomerContracts'] = requestParameters.fB2BCustomerContracts;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.searchQueryContext !== undefined) {
            queryParameters['searchQueryContext'] = requestParameters.searchQueryContext;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/search`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductSearchPageFromJSON(jsonValue));
    }

    /**
     */
    async getProducts(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductSearchPage> {
        const response = await this.getProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductsBulkRaw(requestParameters: GetProductsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getProductsBulk.');
        }

        if (requestParameters.bulkProductRequest === null || requestParameters.bulkProductRequest === undefined) {
            throw new runtime.RequiredError('bulkProductRequest','Required parameter requestParameters.bulkProductRequest was null or undefined when calling getProductsBulk.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.omitRestrictions !== undefined) {
            queryParameters['omitRestrictions'] = requestParameters.omitRestrictions;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/bulk`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkProductRequestToJSON(requestParameters.bulkProductRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListFromJSON(jsonValue));
    }

    /**
     */
    async getProductsBulk(requestParameters: GetProductsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductList> {
        const response = await this.getProductsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductsBulkSolrRaw(requestParameters: GetProductsBulkSolrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductSearchPage>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getProductsBulkSolr.');
        }

        if (requestParameters.bulkProductRequest === null || requestParameters.bulkProductRequest === undefined) {
            throw new runtime.RequiredError('bulkProductRequest','Required parameter requestParameters.bulkProductRequest was null or undefined when calling getProductsBulkSolr.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.q !== undefined) {
            queryParameters['q'] = requestParameters.q;
        }

        if (requestParameters.searchQueryContext !== undefined) {
            queryParameters['searchQueryContext'] = requestParameters.searchQueryContext;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/bulk/solr`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkProductRequestToJSON(requestParameters.bulkProductRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductSearchPageFromJSON(jsonValue));
    }

    /**
     */
    async getProductsBulkSolr(requestParameters: GetProductsBulkSolrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductSearchPage> {
        const response = await this.getProductsBulkSolrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the stock level of a product for the store.
     * Retrieves the stock level of a product.
     */
    async getStoreProductStockRaw(requestParameters: GetStoreProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stock>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getStoreProductStock.');
        }

        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling getStoreProductStock.');
        }

        if (requestParameters.storeName === null || requestParameters.storeName === undefined) {
            throw new runtime.RequiredError('storeName','Required parameter requestParameters.storeName was null or undefined when calling getStoreProductStock.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/{productCode}/stock/{storeName}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))).replace(`{${"storeName"}}`, encodeURIComponent(String(requestParameters.storeName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StockFromJSON(jsonValue));
    }

    /**
     * Retrieves the stock level of a product for the store.
     * Retrieves the stock level of a product.
     */
    async getStoreProductStock(requestParameters: GetStoreProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stock> {
        const response = await this.getStoreProductStockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the suggestions related to a specified term and limits the results according to the value of the max parameter.
     * Retrieves the available suggestions.
     */
    async getSuggestionsRaw(requestParameters: GetSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuggestionList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getSuggestions.');
        }

        if (requestParameters.term === null || requestParameters.term === undefined) {
            throw new runtime.RequiredError('term','Required parameter requestParameters.term was null or undefined when calling getSuggestions.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.max !== undefined) {
            queryParameters['max'] = requestParameters.max;
        }

        if (requestParameters.term !== undefined) {
            queryParameters['term'] = requestParameters.term;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/products/suggestions`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuggestionListFromJSON(jsonValue));
    }

    /**
     * Retrieves the suggestions related to a specified term and limits the results according to the value of the max parameter.
     * Retrieves the available suggestions.
     */
    async getSuggestions(requestParameters: GetSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuggestionList> {
        const response = await this.getSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetProductsBulkSolrSearchQueryContextEnum = {
    ContactAddress: 'CONTACT_ADDRESS',
    Default: 'DEFAULT',
    BillingAddress: 'BILLING_ADDRESS',
    Suggestions: 'SUGGESTIONS',
    User: 'USER',
    FlSearchProducts: 'FL_SEARCH_PRODUCTS',
    OrgSearch: 'ORG_SEARCH'
} as const;
export type GetProductsBulkSolrSearchQueryContextEnum = typeof GetProductsBulkSolrSearchQueryContextEnum[keyof typeof GetProductsBulkSolrSearchQueryContextEnum];
